module.exports = __webpack_public_path__ + "static/w-wilfan-d5e45f90be3c5e3e648823910f8165c6.jpg";